<template>
  <div>
    <v-card>
      <v-img max-height="85" src="@/assets/img/background.png">
        <v-app-bar flat class="mt-2" color="rgba(0, 0, 0, 0)">
          <v-btn color="white" @click="goBack()" icon>
            <v-icon>mdi-chevron-left</v-icon>
          </v-btn>
          <p class="text-white-title mt-4">Ubah Berita</p>
        </v-app-bar>
      </v-img>
    </v-card>
    <div class="d-flex justify-center mx-2 mt-3 w-100" fluid>
      <v-card class="px-2 w-50">
        <ValidationObserver ref="form" v-slot="{ handleSubmit }">
          <v-form @submit.prevent="handleSubmit(submitForm)">
            <v-row>
              <v-col cols="12" lg="12" md="12" sm="12" xs="12" class="pb-0">
                <v-img
                  :src="res_newsDetail.banner_image_url"
                  contain
                  :aspect-ratio="16 / 9"
                  class="mb-3"
                  min-height="200px"
                  max-height="500px"
                ></v-img>
                <ValidationProvider v-slot="{ errors }" name="Benner">
                  <v-file-input
                    accept="image/*"
                    v-model="image"
                    counter
                    outlined
                    :error-messages="errors"
                    label="Click to edit Benner Image"
                  ></v-file-input>
                  <p class="text-grey-sm">*Gambar harus kotak</p>
                </ValidationProvider>
              </v-col>
              <v-col cols="12">
                <ValidationProvider v-slot="{ errors }" name="link">
                  <v-text-field
                    label="Link"
                    v-model="link"
                    required
                    outlined
                    disabled
                    :error-messages="errors"
                  ></v-text-field>
                </ValidationProvider>
              </v-col>
              <v-col cols="12">
                <ValidationProvider
                  v-slot="{ errors }"
                  name="Judul"
                  rules="required"
                >
                  <v-text-field
                    label="Judul Berita"
                    v-model="judul"
                    required
                    outlined
                    placeholder="Laporan Bulan Januari 2020"
                    :disabled="loading"
                    :error-messages="errors"
                  ></v-text-field>
                </ValidationProvider>
              </v-col>
              <v-col cols="12">
                <p class="app-title-small text-sm ma-0">
                  Deskripsi
                </p>
                <ValidationProvider
                  v-slot="{ errors }"
                  name="Deskripsi"
                  rules="required"
                >
                  <vue-editor
                    v-model="content"
                    :error-messages="errors"
                    :editor-toolbar="customToolbar"
                  ></vue-editor>
                </ValidationProvider>
              </v-col>
              <v-col cols="12">
                <ValidationProvider
                  v-slot="{ errors }"
                  name="status"
                  rules="required"
                >
                  <v-switch
                    v-model="status"
                    :label="`status ${status ? 'aktif' : 'tidak aktif'}`"
                    required
                    :disabled="loading"
                    :error-messages="errors"
                  ></v-switch>
                </ValidationProvider>
              </v-col>
            </v-row>
            <div class="ma-3">
              <v-btn
                type="submit"
                color="#f58522"
                class="text-center w-100"
                dark
                :loading="loading"
                block
              >
                <span class="text-capitalize">Tambahkan</span>
              </v-btn>
              <v-btn
                @click.prevent="goBack"
                color="#008ef8"
                class="text-center w-100"
                dark
                block
                text
              >
                <span class="text-capitalize">Cancel</span>
              </v-btn>
            </div>
          </v-form>
        </ValidationObserver>
      </v-card>
    </div>
    <!-- -------------------- dialog ----------------------- -->
    <!-- dialog success -->
    <v-dialog v-model="dialog" persistent max-width="350">
      <v-card class="pa-8 pb-10 d-flex flex-column justify-center">
        <v-icon color="green" size="100px">mdi-checkbox-marked-circle</v-icon>
        <v-card-title class="title-card mx-auto text-center"
          >Berhasil Ubah Berita</v-card-title
        >
        <v-card-actions class="pa-0">
          <v-spacer></v-spacer>
          <v-btn
            @click.prevent="closeSuccessNavigate"
            color="#f58522"
            class="mt-3 w-full"
            width="100%"
            dark
          >
            <span class="text-capitalize">Okay</span>
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
    <!-- dialog failed -->
    <v-dialog v-model="dialog2" persistent max-width="350">
      <v-card class="pa-8 pb-10 d-flex flex-column justify-center">
        <v-icon color="#F32626" size="100px">mdi-alert-circle-outline</v-icon>
        <v-card-title class="title-card mx-auto text-center"
          >Gagal Ubah Berita!</v-card-title
        >
        <p class="mx-auto">{{ errorMessage }}</p>
        <v-card-actions class="pa-0">
          <v-spacer></v-spacer>
          <v-btn
            @click.prevent="dialog2 = false"
            color="#f58522"
            class="mt-3 w-full"
            width="100%"
            dark
          >
            <span class="text-capitalize">Okay</span>
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
    <!-- -------------------- end dialog ----------------------- -->
  </div>
</template>

<script>
import { VueEditor } from "vue2-editor";
import { createNamespacedHelpers } from "vuex";
const news = createNamespacedHelpers("news");

export default {
  name: "Home",
  mounted() {
    this.$store.commit("news/SET_IDNEWS", this.$route.params.id);
    this.$store.dispatch("news/getNewsDetail");
  },
  computed: {
    ...news.mapState(["res_newsDetail"])
  },
  data() {
    return {
      content: null,
      errors: false,
      loading: false,
      dialog2: false,
      dialog: false,
      errorMessage: null,
      customToolbar: [
        [{ header: [false, 1, 2, 3, 4, 5, 6] }],
        ["bold", "italic", "underline", "strike"], // toggled buttons
        [
          { align: "" },
          { align: "center" },
          { align: "right" },
          { align: "justify" }
        ],
        ["blockquote", "code-block"],
        [{ list: "ordered" }, { list: "bullet" }, { list: "check" }],
        [{ indent: "-1" }, { indent: "+1" }], // outdent/indent
        [{ color: [] }, { background: [] }], // dropdown with defaults from theme
        ["link"],
        ["clean"]
      ],
      image: null,
      judul: null,
      status: null,
      link: null,
      resLink: null
    };
  },
  components: {
    VueEditor
  },
  watch: {
    res_newsDetail(val) {
      this.judul = val.title;
      this.link = val.slug;
      this.reslink = val.slug;
      this.content = val.content;
      this.status = val.status;
    }
  },
  methods: {
    goBack() {
      this.$router.go(-1);
    },
    closeSuccessNavigate() {
      this.$router.go(-1);
    },
    checker() {
      this.loading = true;
      const data = {
        title: this.link
      };
      this.$store.commit("news/SET_NAMESLUG", data);
      this.$store
        .dispatch("news/postCreateSlug")
        .then(response => {
          const res = response.data;
          console.log(this.slug);
          if (res) {
            this.dialog = true;
            this.submitForm();
          } else {
            this.submitForm();
            this.dialog2 = true;
          }
        })
        .catch(error => {
          const message = error.response.data.status.message;
          this.errorMessage = message;
          this.dialog2 = true;
          this.loading = false;
        });
    },
    submitForm() {
      // button effect

      let param = new FormData();
      param.append("title", this.judul);
      param.append("content", this.content);
      param.append("slug", this.link);
      param.append("banner", this.image);
      param.append("status", this.status);

      this.$store.commit("news/SET_IDNEWS", this.$route.params.id);
      this.$store.commit("news/SET_DATANEWS", param);
      this.$store
        .dispatch("news/putNews")
        .then(response => {
          const res = response.data;
          console.log(res);
          if (res) {
            this.dialog = true;
            this.loading = false;
          } else {
            this.dialog2 = true;
            this.loading = false;
          }
        })
        .catch(error => {
          const message = error.response.data.status.message;
          this.errorMessage = message;
          this.dialog2 = true;
          this.loading = false;
        });
    }
  }
};
</script>
